import React from 'react';

import {Button} from '@newsela/angelou';
import {actionNames, objectTypes, withTrackEvent} from '@newsela/snitch';
import PropTypes from 'prop-types';

const ButtonWithTrackEvent = withTrackEvent(Button);

const SupportCenterChatButton = ({launchChat}) => (
  <ButtonWithTrackEvent
    flavor={Button.flavors.secondary}
    dataProps={{'data-qa-selector': 'support-center-chat-button'}}
    onClick={launchChat}
    actionName={actionNames.interact}
    objectType={objectTypes.user}
    streamProperties={{description: 'Salesforce Support chat button clicked'}}
    __cssFor={{root: {width: '100%', display: 'flex', justifyContent: 'center'}}}
  >
    Chat with support
  </ButtonWithTrackEvent>
);

SupportCenterChatButton.propTypes = {
  launchChat: PropTypes.func,
};

SupportCenterChatButton.displayName = 'SupportCenterChatButton';
export {SupportCenterChatButton};
